import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PlanningActivityAccountsIndicatorCtrl implements IController {
  activity: any;
  private accountNames: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {_.map(this.activity.stopActivities, 'accountName')
    this.accountNames = _.get(this.activity, 'stopActivities.length') ?
      _.chain(this.activity.stopActivities)
        .map('accountName')
        .uniq()
        .value() :
      [this.activity.accountName];
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj.activity && !onChangesObj.activity.isFirstChange()) {
          this.$onInit();
        }
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityAccountsIndicator', {
    bindings: {
      activity: '<'
    },
    template: require("./planning-activity-accounts-indicator.html").default,
    controller: PlanningActivityAccountsIndicatorCtrl
  });
